export default __webpack_public_path__ + "media/images/backgrounds/bg-06-1973x720-0c0ad3653f4afb2c10ff23520dd3e29e.jpg";